// Custom components
import React, { forwardRef } from "react";

export type InputFieldProps = {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  autoFocus?: boolean;
  autoComplete?: string;
  required?: boolean;
  "aria-invalid"?: boolean | "false" | "true" | "grammar" | "spelling";
  "aria-describedby"?: string;
};

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  function InputField(props, ref) {
    const {
      label,
      id,
      extra,
      type,
      placeholder,
      variant,
      state,
      disabled,
      value,
      onChange,
      onBlur,
      name,
      autoFocus,
      autoComplete,
      required,
      "aria-invalid": ariaInvalid,
      "aria-describedby": ariaDescribedby,
    } = props;

    const isAuth = variant === "auth";
    const controlled = value !== undefined;

    return (
      <div className={`${extra}`}>
        <label
          htmlFor={id}
          className={`${isAuth ? "text-xs font-normal text-[#222] ml-0" : "text-sm text-navy-700 dark:text-white ml-3 font-bold"}`}
        >
          {label}
        </label>
        <input
          ref={ref}
          disabled={disabled}
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          required={required}
          aria-invalid={ariaInvalid}
          aria-describedby={ariaDescribedby}
          {...(controlled ? { value, onChange } : {})}
          onBlur={onBlur}
          className={`mt-1 flex h-10 w-full items-center justify-center rounded-md border px-2.5 py-2 text-xs outline-none focus:ring-1 ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
                ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                : state === "success"
                  ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                  : isAuth
                    ? "border-[#EEE] bg-white text-[#222] placeholder:text-[#6D6D6D] focus:ring-[#222] focus:border-[#222]"
                    : "border-gray-200 dark:!border-white/10 dark:text-white"
          }`}
        />
      </div>
    );
  }
);

export default InputField;
